import React, { Component } from 'react';
import $ from 'jquery';
import { Link,browserHistory} from 'react-router';
import { Modal,Button } from 'react-bootstrap';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
export default class Ab_Login extends Component {
	constructor(props,context){
		super(props);
		this.router= context.router;
		this.state={
			err: false,
			err_mob: false,
			err_pass: false,
			invalid_pass: '',
			invalid_num: '',
			ab_modal:false,
		};
		this.handleSubmit=this.handleSubmit.bind(this);
		this.onMobileChange=this.onMobileChange.bind(this);
		this.redLogin=this.redLogin.bind(this);
		this.close=this.close.bind(this);
	}
	close(){
	    this.setState({
	      ab_modal: true,
	    })
  	}

	handleSubmit(event){
		event.preventDefault();
		localStorage.setItem('mobile_number',this.refs.mobile.value);
		var data1= {
			from:'mobile_web',
			mobile: this.refs.mobile.value,
			password: this.refs.pass.value,
			device_id:localStorage.getItem('push_device_id'),
			version: '',
			platform: '',
		}
		var data2=JSON.stringify(data1);

		$.ajax({
			method: 'POST',
			url: baseUrl+'signupAB',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
				if(data.status === 'error' && data.message === "Mobile number already registered with AquaDeals"){
			          this.setState({
			              ab_modal: true,
			          });
        		}
				if(data.status==='success'){
					localStorage.setItem('token',data.result[0].token);
					localStorage.setItem('user_id',data.result[0].id);
					browserHistory.push('/');
				}
				if(data.status==='error'){
					this.setState({
						err:true,
						invalid_num: data.message,
					})
				}
			}.bind(this),
			error: function(err){
				// console.log("AB Login Fail"+err);
			}
		})
	}
	redLogin(){
   	 browserHistory.push('/account');
    	// window.location.reload();
  }
	onMobileChange(event){
     	var invalidChars = /[^0-9]/gi;
      		if(invalidChars.test(event.target.value)) {
            	event.target.value = event.target.value.replace(invalidChars,"");
      		}
      		else{
	           this.setState({
	           		err: true,
	        	});
    		}
  	}
	render(){
	return (

      <div className='user_form'>
         <Link to={'/login'} className="back_icon"><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt="" /></i></Link>
           <div className="container pag_cntnt">
              <div className="row" style={{marginLeft:'0',marginRight:'0'}}>
                <h5 className="sign_in_title">AquaBrahma Login</h5>
  				<form onSubmit={this.handleSubmit} className="text-center login_form">
                   <div className="reg_group">
                        <label><span>+91</span></label>
                   		<input type="text" required placeholder="Enter Mobile" ref="mobile"  maxLength={10} onChange={this.onMobileChange} />
          				<span className="highlight"></span>
          				<span className="bar"></span>
          				{this.state.err ? this.state.invalid_num : '' }
                   </div>
                   <div className="clr">&nbsp;</div>
                  <div className="reg_group">
	                    <input type="password" placeholder="Password" ref="pass" required  />
	                    <span className="highlight"></span>
	                    <span className="bar"></span>
	                    {this.state.err_pass ? this.state.invalid_pass : ''}
                  </div>
                  <div className="clr"></div>
                  <div className="clr">&nbsp;</div>
                  <button type="submit" className="btn mob_regbtn_ablogin" onSubmit={this.handleSubmit} >ENTER</button>
  				</form>
              </div>
              <Modal className="ab_login_modal" show={this.state.ab_modal} onHide={this.close}  >
        		<Modal.Body>
            		<h4 style={{fontSize:14+'px', color:'#222'}}>You are already registered with AquaDeals.</h4>
            		<Button style={{border: 'none',background: '#fff none repeat scroll 0 0',color: 'green',float: 'right' }} onClick={this.redLogin}>OK</Button>
        		</Modal.Body>
    		</Modal>
          </div>
        {/*<section className="tot_pag mob_ab_login_page">
		    <div className="page_hdr">
		        <div className="container">
		              <h5><Link to="/login"><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Login</h5>
		              <a href="/" className="home_newicon"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home"/></a>
		        </div>
		    </div>
			<div className="clr">&nbsp;</div>
			<div className="clr">&nbsp;</div>
		    <div className="col-md-6 col-md-offset-3">
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
			    <div className="">
    				<div className="enquire_form ab_form">
                		<div className="login_logo" style={{textAlign: 'center',marginBottom: 20+'px'}}>
            	    		<img src={baseAssets+'icons/web_icons/ab-logo.png'} title="" alt="Aquadeals" />
            			</div>
						<div className="login_form" style={{marginLeft: '30px',marginRight: '30px'}}>
                			<form onSubmit={this.handleSubmit} className="mtrl_elmnts">
				                <div className="group">      
                      				<img src={baseAssets+'icons/web_icons/ab_cell_dl.png'} alt="" style={{position:'absolute',top:'11px',left:'0px'}} />
                      				<input type="text" required placeholder="Enter Mobile" ref="mobile"  maxLength={10} onChange={this.onMobileChange} />
                      				<span className="highlight"></span>
                      				<span className="bar"></span>
                      				{this.state.err ? this.state.invalid_num : '' }
                      			</div>
                				<div className="group">      
                    				<img src={baseAssets+'icons/web_icons/ab_pass.png'} alt="" style={{position:'absolute',top:'11px',left:'0px'}} />
                    				<input type="password" placeholder="Password" ref="pass" required  />
				                    <span className="highlight"></span>
				                    <span className="bar"></span>
				                    {this.state.err_pass ? this.state.invalid_pass : ''}
                    			</div>
                    			<div className="clr">&nbsp;</div>
                    			<div className="clr">&nbsp;</div>
                    			<div>
                    				<button type="submit" className="btn mob_ab_login_btn" onSubmit={this.handleSubmit} >Enter <i className="glyphicon glyphicon-menu-right"></i></button>
                    			</div>
				            </form>
         				</div>
    					<div className="clr">&nbsp;</div>
    				</div>
			 	</div>
    		</div>
    		<Modal className="ab_login_modal" show={this.state.ab_modal} onHide={this.close}  >
        		<Modal.Body>
            		<h4 style={{fontSize:14+'px', color:'#222'}}>You are already registered with AquaDeals.</h4>
            		<Button style={{border: 'none',background: '#fff none repeat scroll 0 0',color: 'green',float: 'right' }} onClick={this.redLogin}>OK</Button>
        		</Modal.Body>
    		</Modal>
		</section> */}
 </div>		
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Auth/ab_login.js
 **/